import * as React from "react";

import { CrossfitTableColumnGroupColumnProps } from "./CrossfitTableColumnGroupColumn";

interface ColumnGroupProps {
    startCol?: number;
    endCol?: number;
    cutCols?: Array<[number, number]>;
    hiddenColgroup: number[];
    children?: React.ReactNode;
}

export function CrossfitTableColumnGroup(props: ColumnGroupProps): JSX.Element {
    const count = React.Children.count(props.children);
    const { startCol = 0, endCol = count, cutCols = [], hiddenColgroup = [] } = props;

    const cols = React.Children.toArray(props.children)
        .slice(startCol, endCol)
        .map((child, index) => {
            const isCollapsedColumn = cutCols.some(([start, end]) => index > start && index <= end);
            const inHiddenColumn = hiddenColgroup.includes(index);
            if (isCollapsedColumn || inHiddenColumn) {
                if (React.isValidElement(child)) {
                    return React.cloneElement<CrossfitTableColumnGroupColumnProps>(
                        child as React.ReactElement<CrossfitTableColumnGroupColumnProps>,
                        {
                            collapsed: isCollapsedColumn || inHiddenColumn,
                        }
                    );
                }
            }
            return child;
        });

    return <colgroup>{cols}</colgroup>;
}
